(() => {
  if (customElements.get('fp-product-markdown')) return;
  const node = (tag, text) => {
    const element = document.createElement(tag);
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const closing = (text, marker, start) => {
    let at = text.indexOf(marker, start);
    while (at >= 0) {
      let slashes = 0;
      for (let i = at - 1; i >= 0 && text[i] === '\\'; i--) slashes++;
      if (slashes % 2 === 0) return at;
      at = text.indexOf(marker, at + marker.length);
    }
    return -1;
  };
  function inline(text, interactive = true, depth = 0) {
    const output = document.createDocumentFragment();
    if (depth > 8) { output.append(text); return output; }
    let buffer = '';
    const flush = () => { if (buffer) output.append(buffer); buffer = ''; };
    for (let i = 0; i < text.length;) {
      if (text[i] === '\\' && /[\\`*_~|[\]()#>+-]/.test(text[i + 1] || '')) {
        buffer += text[i + 1]; i += 2; continue;
      }
      if (text[i] === '`') {
        const end = closing(text, '`', i + 1);
        if (end > i + 1) { flush(); output.append(node('code', text.slice(i + 1, end))); i = end + 1; continue; }
      }
      if (interactive && text[i] === '[') {
        const link = text.slice(i).match(/^\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)/i);
        if (link) {
          try {
            const url = new URL(link[2]);
            if (['http:', 'https:'].includes(url.protocol) && !url.username && !url.password) {
              flush(); const anchor = node('a'); anchor.href = url.href;
              anchor.append(inline(link[1], false, depth + 1)); output.append(anchor);
              i += link[0].length; continue;
            }
          } catch (_) { }
        }
      }
      const marker = ['***', '**', '__', '~~', '||', '*', '_'].find(value => text.startsWith(value, i));
      if (marker && !(marker.startsWith('_') && /\w/.test(text[i - 1] || ''))) {
        const end = closing(text, marker, i + marker.length);
        const content = end < 0 ? '' : text.slice(i + marker.length, end);
        if (content && content.trim() === content && (marker !== '||' || interactive)) {
          flush();
          if (marker === '||') {
            const button = node('button'); button.type = 'button'; button.className = 'fp-markdown-spoiler';
            button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-label', document.body.dataset.revealText);
            const hidden = node('span'); hidden.setAttribute('aria-hidden', 'true');
            hidden.append(inline(content, false, depth + 1)); button.append(hidden);
            button.addEventListener('click', () => {
              const expanded = button.getAttribute('aria-expanded') !== 'true';
              button.setAttribute('aria-expanded', String(expanded));
              button.setAttribute('aria-label', expanded ? document.body.dataset.hideText : document.body.dataset.revealText);
              hidden.setAttribute('aria-hidden', String(!expanded));
            });
            output.append(button);
          } else {
            const tag = ({'***':'strong','**':'strong','__':'u','~~':'s','*':'em','_':'em'})[marker];
            const element = node(tag);
            if (marker === '***') { const emphasis = node('em'); emphasis.append(inline(content, interactive, depth + 1)); element.append(emphasis); }
            else element.append(inline(content, interactive, depth + 1));
            output.append(element);
          }
          i = end + marker.length; continue;
        }
      }
      buffer += text[i++];
    }
    flush(); return output;
  }
  function render(text) {
    const output = document.createDocumentFragment();
    const lines = text.replace(/\r\n?/g, '\n').split('\n');
    let paragraph = null, list = null, quote = null;
    const reset = () => { paragraph = null; list = null; quote = null; };
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      if (!line.trim()) { reset(); continue; }
      if (/^\s*```/.test(line)) {
        reset(); const code = [];
        while (++i < lines.length && !/^\s*```\s*$/.test(lines[i])) code.push(lines[i]);
        const pre = node('pre'); pre.append(node('code', code.join('\n'))); output.append(pre); continue;
      }
      const heading = line.match(/^(#{1,3})\s+(.+)$/);
      if (heading) {
        reset(); const title = node('h' + (heading[1].length + 1));
        title.append(inline(heading[2])); output.append(title); continue;
      }
      if (/^\s*(?:---+|\*\*\*+)\s*$/.test(line)) { reset(); output.append(node('hr')); continue; }
      const item = line.match(/^\s*(?:([-+*])|(\d+)\.)\s+(.+)$/);
      if (item) {
        paragraph = null; quote = null;
        const tag = item[2] ? 'ol' : 'ul';
        if (!list || list.localName !== tag) {
          list = node(tag); if (item[2]) list.start = Number(item[2]); output.append(list);
        }
        const entry = node('li'); entry.append(inline(item[3])); list.append(entry); continue;
      }
      const quoted = line.match(/^>\s?(.*)$/);
      if (quoted) {
        paragraph = null; list = null;
        if (!quote) { quote = node('blockquote'); output.append(quote); }
        else quote.append(node('br'));
        quote.append(inline(quoted[1])); continue;
      }
      list = null; quote = null;
      if (!paragraph) { paragraph = node('p'); output.append(paragraph); }
      else paragraph.append(node('br'));
      paragraph.append(inline(line));
    }
    return output;
  }
  customElements.define('fp-product-markdown', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.rendered) return;
      const source = this.textContent;
      this.replaceChildren(render(source));
      this.dataset.rendered = 'true';
    }
  });
})();
